module.exports = __webpack_public_path__ + "static/media/icon_snacks.c7188e07.svg";